export default "__VITE_ASSET__BpYXA6JN__"